import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { OktaAuthStateService } from "@okta/okta-angular";
import { map, take } from "rxjs/operators";

export const authGuard: CanActivateFn = (route, state) => {
  // TODO: Re-enable Okta auth when configured
  // Temporary: Allow all access for development
  return true;

  /* Original Okta auth guard code:
  const authStateService = inject(OktaAuthStateService);
  const router = inject(Router);

  return authStateService.authState$.pipe(
    take(1),
    map((authState) => {
      if (authState?.isAuthenticated) {
        return true;
      }
      // Store the attempted URL for redirecting after login
      router.navigate(["/login"], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }),
  );
  */
};
